import StackDrawer from "@/components/ui/stack-drawer";

/**
 * InvoiceDrawer is a thin wrapper around StackDrawer for backwards compatibility.
 * Prefer importing StackDrawer directly from @/components/ui/stack-drawer.
 */
const InvoiceDrawer = StackDrawer;

export default InvoiceDrawer;
